var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 114,
    viewBox: "0 0 125 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2048 101.538C47.8534 105.029 55.3925 107 63.3923 107C90.3788 107 112.123 84.567 112.123 57.0607C112.123 29.5543 90.3788 7.12158 63.3923 7.12158C36.4057 7.12158 14.6615 29.5543 14.6615 57.0607C14.6615 69.0979 18.8257 80.1635 25.7711 88.8026L21.5108 103.146L19.8686 108.674L25.3382 106.845L41.2048 101.538Z",
    stroke: "#83B2A3",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9233 44.4357C59.9233 39.4988 55.9023 35.3716 51.0925 35.3716C46.2827 35.3716 42.2617 39.4988 42.2617 44.4357",
    stroke: "#83B2A3",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7229 44.4357C92.7229 39.4988 88.8456 35.3716 84.2075 35.3716C79.5695 35.3716 75.6921 39.4988 75.6921 44.4357",
    stroke: "#83B2A3",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5844 63.8592C77.5844 68.7962 73.5634 72.9233 68.7536 72.9233C63.9438 72.9233 59.9229 68.7962 59.9229 63.8592",
    stroke: "#83B2A3",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 45.0835,
    width: 68.7538,
    height: 15.5385,
    rx: 7.76923,
    fill: "#00E6AB",
    fillOpacity: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2461,
    y: 60.6216,
    width: 68.7538,
    height: 15.5385,
    rx: 7.76923,
    fill: "#00E6AB",
    fillOpacity: 0.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 76,
    width: 68.7538,
    height: 14.891,
    rx: 7.44551,
    fill: "#00E6AB",
    fillOpacity: 0.13
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0392 17.0991L17.9641 20.1012L24.6106 13.2791",
    stroke: "#83B2A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.332 32.5361L116.257 35.5383L122.903 28.7161",
    stroke: "#83B2A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.023 11.6218C107.804 11.6218 109.992 9.31884 109.992 6.5609C109.992 3.80296 107.804 1.5 105.023 1.5C102.242 1.5 100.054 3.80296 100.054 6.5609C100.054 9.31884 102.242 11.6218 105.023 11.6218Z",
    stroke: "#83B2A3",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6692 99.6731C14.4502 99.6731 16.6384 97.3701 16.6384 94.6122C16.6384 91.8542 14.4502 89.5513 11.6692 89.5513C8.88811 89.5513 6.69995 91.8542 6.69995 94.6122C6.69995 97.3701 8.88812 99.6731 11.6692 99.6731Z",
    stroke: "#83B2A3",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.008 99.6731C119.789 99.6731 121.977 97.3701 121.977 94.6122C121.977 91.8542 119.789 89.5513 117.008 89.5513C114.226 89.5513 112.038 91.8542 112.038 94.6122C112.038 97.3701 114.226 99.6731 117.008 99.6731Z",
    stroke: "#83B2A3",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiMessage);
export default __webpack_public_path__ + "static/media/emoji _message.8be236a77533f639801209e58c4e2cb0.svg";
export { ForwardRef as ReactComponent };